import { veaTheme } from "@kleros/ui-components-library";

export const theme = {
  ...veaTheme,
  color: {
    pink: "#FAD3F1",
    light: "#FFFDF5",
    dark: "#1B003F",
    white: "#FFFFFF",
    black: "#000000",
    blue: "#69C3FC",
    purple: "#1F0847",
    grey: "#E5E5E5",
    lightBlue: "#BECCE5",
    secondaryBlue: "#42498F",
    secondaryPurple: "#200F47",
    lightRed: "#FF5A78",
    lightYellow: "#FFC46B",
    turquoise: "#6CC5FF",
    lightPurple: "#B45FFF",
    darkBlue: "#7E93FF",
    smoke: "#BECCE5",
    teal: "#00B8C4",
    green: "#65DC7F",
    midnightPurple: "#2E206C",
  },
};
